import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';

export default class OrgUnit extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/orgunit/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;
        this.httpPost("api/v1/orgunit/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.global.company.id,
            name: this.state.data.record.name,
            code: this.state.data.record.code,
            moeinAccountId: this.state.data.record.moeinAccountId,
            parentId: this.state.data.record.parentId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPersonType(v, e) {
        this.state.data.record.type = v;
        this.setState({ data: this.state.data });
    }
    setMoeinAccount(e) {
        this.state.data.record.moeinAccountId = e.value;
        this.state.data.record.moeinAccountName = e.label;
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش واحد سازمانی" : "افزودن واحد سازمانی جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">عنوان</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">واحد بالاسری</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.parentId} onChange={e => this.state.data.record.parentId = e.target.value}>
                                                    <option value={this.getDefaultGuid()}>انتخاب کنید</option>
                                                    {this.state.data.parents.map(p => <option value={p.id}>{p.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">کد</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control ltr " type="text" defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = parseInt(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">معین پیش فرض</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    value={
                                                        this.state.data.record.moeinAccountId != this.defaultGuid()
                                                            ? [
                                                                {
                                                                    value: this.state.data.record.moeinAccountId,
                                                                    label: this.state.data.record.moeinAccountName,
                                                                },
                                                            ]
                                                            : null
                                                    }
                                                    isMulti={false}
                                                    placeholder="انتخاب تنخواه گردان"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                                                    onChange={(e) => this.setMoeinAccount(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف </button>
                            <button type="submit" onClick={e => this.save()} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}